import { cx, text, focus } from '../../../lib/ui-primitives'
import { Button } from '../../primitives'
import { RefreshIcon } from '../../icons'

// ============================================
// DASHBOARD HEADER
// Admin dashboard top navigation
// ============================================

export interface DashboardHeaderProps {
  title: string
  subtitle?: string
  icon?: string
  onRefresh?: () => void
  onExit?: () => void
}

/**
 * DashboardHeader - Admin dashboard header with navigation
 *
 * Features:
 * - Business branding
 * - Refresh action
 * - Exit to kiosk
 */
export function DashboardHeader({
  title,
  subtitle,
  icon = '🏧',
  onRefresh,
  onExit,
}: DashboardHeaderProps) {
  return (
    <header className="bg-kiosk-surface border-b border-white/10 px-4 sm:px-6 py-4">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        {/* Branding */}
        <div className="flex items-center gap-3 sm:gap-4">
          <span className="text-2xl" aria-hidden="true">{icon}</span>
          <div>
            <h1 className={cx(text.h3, 'tracking-tight')}>{title}</h1>
            {subtitle && (
              <p className={cx('text-sm', text.tertiary)}>{subtitle}</p>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2 sm:gap-3">
          {onRefresh && (
            <button
              onClick={onRefresh}
              className={cx(
                'p-2.5 rounded-xl bg-white/5 border border-white/10',
                'hover:bg-white/10 hover:border-white/20',
                'transition-colors',
                focus.ring
              )}
              title="Refresh orders"
              aria-label="Refresh orders"
            >
              <RefreshIcon />
            </button>
          )}
          {onExit && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onExit}
            >
              Exit Admin
            </Button>
          )}
        </div>
      </div>
    </header>
  )
}
